import { useState } from 'react';

const faqs = [
  {
    question: '91.cc 是什么类型的平台？',
    answer: '91.cc 是一个综合性的网络服务平台，为用户提供丰富的在线功能和优质的服务体验。平台集成了内容浏览、社区互动、个人管理等多种功能模块，致力于为用户创造安全、便捷、高效的网络使用环境。',
  },
  {
    question: '如何安全访问 91.cc？',
    answer: '建议通过 91.cc 官方网站直接访问，或使用官方移动客户端。请始终从官方渠道获取访问地址，不要点击来源不明的链接。启动前请检查网络环境安全，建议使用个人私有网络，避免在公共 Wi-Fi 下进行账户操作。',
  },
  {
    question: '忘记密码如何找回？',
    answer: '在登录页面点击"忘记密码"，输入注册时使用的邮箱地址，系统会发送密码重置邮件。请在 30 分钟内完成重置操作。如未收到邮件，请检查垃圾邮件箱或联系客服。',
  },
  {
    question: '91.cc 是否免费使用？',
    answer: '91.cc 平台基础功能完全免费，注册后即可使用大部分功能。平台也提供了部分高级增值服务，用户可根据自身需求选择是否使用。详细的功能和价格信息，请以平台官方公告为准。',
  },
  {
    question: '如何获取 91.cc 的最新动态？',
    answer: '您可以通过以下方式获取 91.cc 的最新动态：关注 91.cc 官方网站的公告栏目、订阅平台的邮件通知、关注官方社交媒体账号、开启移动客户端的消息推送功能。',
  },
  {
    question: '遇到技术问题如何反馈？',
    answer: '如遇到技术问题，您可以：通过平台内的"帮助与反馈"功能提交问题、联系官方客服邮箱获取技术支持、在社区帮助板块发帖求助。建议提供详细的问题描述和截图，以便技术团队快速定位和解决。',
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const faqJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((faq) => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer,
      },
    })),
  };

  return (
    <section className="w-full bg-background-100 py-14 md:py-20" aria-labelledby="faq-heading">
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(faqJsonLd) }} />
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 id="faq-heading" className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-3">
            常见问题解答
          </h2>
          <p className="text-sm md:text-base text-foreground-600">
            快速了解 91.cc 平台的使用要点和常见疑问
          </p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-background-50 rounded-lg border border-background-200/60 overflow-hidden"
            >
              <button
                className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer hover:bg-background-50/80 transition-colors"
                onClick={() => toggleFAQ(index)}
                aria-expanded={openIndex === index}
              >
                <span className="text-sm md:text-base font-medium text-foreground-900 pr-4">{faq.question}</span>
                <span className={`flex-shrink-0 w-6 h-6 flex items-center justify-center rounded-full transition-transform duration-300 ${openIndex === index ? 'bg-primary-100 text-primary-600 rotate-180' : 'bg-background-100 text-foreground-500'}`}>
                  <i className="ri-arrow-down-s-line text-sm"></i>
                </span>
              </button>
              {openIndex === index && (
                <div className="px-5 pb-4">
                  <p className="text-sm text-foreground-600 leading-relaxed">{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}